import { SelfServiceConfig } from '../services/selfservice-loader.service';
import { EnvironmentDetector } from './environment';
import { DEV_SELFSERVICE_CONFIGS } from './selfservice.config.dev';
import { SIT_SELFSERVICE_CONFIGS } from './selfservice.config.sit';
import { STAGE_SELFSERVICE_CONFIGS } from './selfservice.config.stage';
import { PROD_SELFSERVICE_CONFIGS } from './selfservice.config.prod';


const currentEnvironment = EnvironmentDetector.getEnvironment();
const environmentConfig = EnvironmentDetector.getEnvironmentConfig();

console.log(
  `%c📍 Self-Service Environment: ${environmentConfig.name} (${currentEnvironment.toUpperCase()})`,
  'color: #0066cc; font-weight: bold; font-size: 14px;'
);
console.log(
  `%c🔗 API Base URL: ${environmentConfig.apiBaseUrl}`,
  'color: #0066cc; font-size: 12px;'
);


const environmentConfigs = {
  dev: DEV_SELFSERVICE_CONFIGS,
  sit: SIT_SELFSERVICE_CONFIGS,
  stage: STAGE_SELFSERVICE_CONFIGS,
  prod: PROD_SELFSERVICE_CONFIGS,
};

export const SELFSERVICE_CONFIGS: Record<string, SelfServiceConfig> =
  environmentConfigs[currentEnvironment];


export function getCurrentEnvironment(): string {
  return currentEnvironment;
}


export function getEnvironmentConfig() {
  return environmentConfig;
}
